import { TFunction } from 'react-i18next';
import ContentPagesPostsTab from '../containers/ContentPagesPostsTab/ContentPagesPostsTab';
import { BlogCategoriesTabContainer } from '@/modules/Categories/containers';

export enum ContentPagesTabs {
  BLOG = 'blog',
  BLOG_CATEGORIES = 'blog_categories',
}

export const getContentPagesTabsConfig = (t: TFunction) => [
  {
    label: t('content_pages_tab_blog'),
    key: ContentPagesTabs.BLOG,
    content: <ContentPagesPostsTab />,
  },
  {
    label: t('blog_categories_tab_title', { ns: 'categories' }),
    key: ContentPagesTabs.BLOG_CATEGORIES,
    content: <BlogCategoriesTabContainer />,
  },
];
